import { state } from "@src/state";
export const selectIsScreenFullscreen = () => state.meeting.studio.screen.isPanelFullScreen;
